/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

export const enabledPersonalInformation: { [key in "Birthday"]: boolean } = {
  "Birthday": false,
};
